/* Featured LED strip under Bestselling kits.
   Also owns the homepage mid-page order so kits never sit directly above the video:
   kits → Featured LED → Which scene (patio) → Function selection → video
   → From our own → Product Series */
(function () {
  var MARK = 'leaves-canyon-feature';

  function kits() {
    return (
      document.querySelector('#leaves-home .leaves-warm-flos-host') ||
      document.querySelector('#leaves-home [data-section-id="leaves-2f81"]')
    );
  }

  function video() {
    return document.querySelector('#leaves-home [data-section-id="leaves-26b5"]');
  }

  function patio() {
    return (
      document.querySelector('#leaves-home .leaves-patio-eisku-host') ||
      document.querySelector('#leaves-home [data-section-id="leaves-e165"]')
    );
  }

  function functionSel() {
    return (
      document.querySelector('#leaves-home .leaves-fn-joby-host') ||
      document.querySelector('#leaves-home [data-section-id="leaves-373f"]')
    );
  }

  function factory() {
    return (
      document.querySelector('#leaves-home .leaves-sohub-awards-host') ||
      document.querySelector('#leaves-home [data-section-id="leaves-1e60"]')
    );
  }

  function series() {
    return document.querySelector('#leaves-home [data-section-id="leaves-56f1"]');
  }

  function markup() {
    var cfg = window.LEAVES_CANYON_FEATURE || {};
    var hero = cfg.hero || '';
    return (
      '<div class="leaves-canyon-feature__side">' +
      '<div class="leaves-canyon-feature__copy">' +
      '<h2 class="leaves-canyon-feature__title">Featured: LED Strip</h2>' +
      '<div class="leaves-canyon-feature__body">' +
      '<p>A warm line of light for a wall, an eave, or the edge of a seat. Bend it to the surface and dim it for the evening. Use it on its own, or add it when you build a kit.</p>' +
      '</div>' +
      '<a class="leaves-canyon-feature__shop" href="/pages/configure-v2">Shop Now</a>' +
      '</div></div>' +
      '<div class="leaves-canyon-feature__hero">' +
      '<img src="' +
      hero +
      '" alt="LED strip light along a garden wall" loading="lazy" decoding="async">' +
      '</div>'
    );
  }

  function ensure() {
    var root = document.querySelector('.' + MARK);
    if (root) return root;
    var host = kits();
    if (!host || !host.parentNode) return null;
    root = document.createElement('section');
    root.className = MARK;
    root.setAttribute('aria-label', 'Featured: LED Strip');
    root.innerHTML = markup();
    host.parentNode.insertBefore(root, host.nextSibling);
    return root;
  }

  /** Insert nodes in order as siblings under the same parent. */
  function chain(nodes) {
    var list = nodes.filter(Boolean);
    var i;
    var node;
    var prev;
    var parent;
    for (i = 0; i < list.length; i += 1) {
      node = list[i];
      if (i === 0) continue;
      prev = list[i - 1];
      parent = prev.parentNode;
      if (!parent) continue;
      if (node.parentNode !== parent) {
        parent.insertBefore(node, prev.nextSibling);
      } else if (node.previousElementSibling !== prev) {
        parent.insertBefore(node, prev.nextSibling);
      }
    }
  }

  function place() {
    var host = kits();
    var root = ensure();
    if (!host || !root) return;

    // Keep Featured glued under kits first
    if (root.previousElementSibling !== host && host.parentNode) {
      host.parentNode.insertBefore(root, host.nextSibling);
    }

    // Mid-page stack: kits → LED → patio → function → video → factory → series
    chain([host, root, patio(), functionSel(), video(), factory(), series()]);
  }

  window.leavesPlaceHomeSections = place;

  function boot() {
    place();
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      place();
      if (tries > 50) window.clearInterval(timer);
    }, 80);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
